import { BaseWebComponent } from '../base-components/base-web-component.js';
import { BonusAddAi } from './bonus-add-ai.js';

export abstract class BaBase extends BaseWebComponent {
    public readonly componentId: string
    protected get BaParent(): BonusAddAi | null {
        return this.closest('bonus-add-ai') as BonusAddAi;
    }
    constructor() {
        super();
        this.componentId = this.createRandomId();
    }
    protected buildRenderingData(): Record<string, any> {
        return {
            componentId: this.componentId
        };
    }
}